import { defineStore } from "pinia";
import { GoogleFontsState } from "@/stores/google-fonts/types.ts";
import { loadGoogleFont } from "@/util/loadFonts.js";

async function getGoogleFonts(): Promise<string[]> {
  /*
  To allow for debugging, we use a reduced font list in dev environments.
   */
  return (
    import.meta.env.MODE === "production"
      ? await import("@/stores/google-fonts/google-fonts-api-response.json")
      : await import("@/stores/google-fonts/google-fonts-api-response.dev.json")
  ).default;
}

async function getTopGoogleFonts(): Promise<string[]> {
  return (
    import.meta.env.MODE === "production"
      ? await import("@/stores/google-fonts/google-fonts-top.json")
      : await import("@/stores/google-fonts/google-fonts-top.dev.json")
  ).default;
}

const useGoogleFontsStore = defineStore("google-fonts", {
  state: (): GoogleFontsState => ({
    fonts: [],
    topFonts: [],
  }),
  actions: {
    async load() {
      if (this.fonts.length === 0) {
        this.fonts = await getGoogleFonts();
      }

      if (this.topFonts.length === 0) {
        this.topFonts = await getTopGoogleFonts();
        this.topFonts.forEach(loadGoogleFont);
      }
    },
  },
});

export { useGoogleFontsStore };
